import Backbone from 'backbone'

const PageImageModel = Backbone.Model.extend({
    defaults: {
        index: null,
        slug: null,
        image_prefix: null,
        custom_widths: [],
    }
})

export default PageImageModel
